import { createContext, useContext, useReducer, useEffect } from "react";
import { useProductContext } from "./ProductContext";
import reducer from "../reducer/filterReducer";

const FilterContext = createContext();

const initialState = {
  filter_products: [],
  all_products: [],
  grid_view: true,
  sorting_value: "highest",
  filters: {
    text: "",
    category: "all",
    company: "all",
    color: "all",
    maxPrice: 0,
    price: 0,
    minPrice: 0
  }
};

export const FilterContextProvider = ({ children }) => {
  const { products } = useProductContext();
  const [state, dispatch] = useReducer(reducer, initialState);
  // to set the grid view
  const setGridView = () => {
    return dispatch({ type: "SET_GRID_VIEW" });
  };
  // to set the list view
  const setListView = () => {
    return dispatch({ type: "SET_LIST_VIEW" });
  };
  //sorting value
  const sorting = (event) => {
    let UserValue = event.target.value
    return dispatch({ type: "GET_SORT_VALUE", payload: UserValue });
  }
  // updateFilterValue
  const updateFilterValue = (event) => {
    let name = event.target.name
    let value = event.target.value
    return dispatch({ type: "UPDATE_FILTERS_VALUE", payload: { name, value } })
  }
  // To clear all filter
  const clearFilters = () => {
    dispatch({ type: "CLEAR_FILTERS" })
    console.log("hello")
  }
  //to sort the product
  useEffect(() => {
    dispatch({ type: "FILTER_PRODUCTS" })
    dispatch({ type: "SORTING_PRODUCTS" });
  }, [products, state.sorting_value, state.filters])
  // initialCall
  useEffect(() => {
    dispatch({ type: "LOAD_FILTER_PRODUCTS", payload: products });
  }, [products]);

  return (
    <FilterContext.Provider
      value={{ ...state, setGridView, setListView, sorting, updateFilterValue, clearFilters }}>
      {children}
    </FilterContext.Provider>
  );
};
// Custom Hook
export const useFilterContext = () => {
  return useContext(FilterContext);
};